import React from 'react'
import { TabItemProps } from './Tabs.types'

const TabItem: React.FC<TabItemProps> = ({ children }) => {
  return <>{children}</>
}

export default TabItem
